module.exports = __webpack_public_path__ + "static/img/top4-img.511f2e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top4-img.png
// module id = A5Vk
// module chunks = 1